export default __webpack_public_path__ + "static/media/graphic_3.1.02b6beb6.svg";